const GET_COORDINATES = 'publicador/ducks/step1Module2/GET_COORDINATES';
const GET_COORDINATES_FAILED = 'publicador/ducks/step1Module2/GET_COORDINATES_FAILED';
const GET_COORDINATES_COMPLETED = 'publicador/ducks/step1Module2/GET_COORDINATES_COMPLETED';

const GET_CEP = 'publicador/ducks/step1Module2/GET_CEP';
const GET_CEP_FAILED = 'publicador/ducks/step1Module2/GET_CEP_FAILED';
const GET_CEP_COMPLETED = 'publicador/ducks/step1Module2/GET_CEP_COMPLETED';

const GET_LOCATION = 'publicador/ducks/step1Module2/GET_LOCATION';
const GET_LOCATION_COMPLETED = 'publicador/ducks/step1Module2/GET_LOCATION_COMPLETED';

const SET_ADDRESS = 'publicador/ducks/step1Module2/SET_ADDRESS';
const SET_SELECTED_PROVINCE = 'publicador/ducks/step1Module2/SET_SELECTED_PROVINCE';
const SET_SELECTED_CITY = 'publicador/ducks/step1Module2/SET_SELECTED_CITY';
const SET_SELECTED_DISTRICT = 'publicador/ducks/step1Module2/SET_SELECTED_DISTRICT';
const SET_SELECTED_SUBDISTRICT = 'publicador/ducks/step1Module2/SET_SELECTED_SUBDISTRICT';
const SET_CEP = 'publicador/ducks/step1Module2/SET_CEP';
const SET_ADDRESS_COMPLEMENT = 'publicador/ducks/step1Module2/SET_ADDRESS_COMPLEMENT';

const RESET_VALUES = 'publicador/ducks/step1Module2/RESET_VALUES';
const RESET_INFO = 'publicador/ducks/step1Module2/RESET_INFO';
const SET_EDITED = 'publicador/ducks/step1Module2/SET_EDITED';
const SET_EDIT_VALUES = 'publicador/ducks/step1Module2/SET_EDIT_VALUES';
const GET_FORM_VALUES = 'publicador/step1Module2/GET_FORM_VALUES';
const GET_FORM_VALUES_COMPLETED = 'publicador/step1Module2/GET_FORM_VALUES_COMPLETED';

const SAVE_STEP1_MODULE_2 = 'publicador/ducks/step1Module2/SAVE_MODULE_2';

const SET_VISIBILITY = 'publicador/ducks/step1Module2/SET_VISIBILITY';
const SET_COORDINATES = 'publicador/ducks/step1Module2/SET_COORDINATES';

export {
  GET_COORDINATES,
  GET_COORDINATES_FAILED,
  GET_COORDINATES_COMPLETED,
  GET_LOCATION,
  GET_LOCATION_COMPLETED,
  SET_ADDRESS,
  SET_SELECTED_PROVINCE,
  SET_SELECTED_CITY,
  SET_SELECTED_DISTRICT,
  SET_SELECTED_SUBDISTRICT,
  SET_VISIBILITY,
  RESET_VALUES,
  SET_EDITED,
  SAVE_STEP1_MODULE_2,
  RESET_INFO,
  SET_EDIT_VALUES,
  GET_FORM_VALUES,
  GET_FORM_VALUES_COMPLETED,
  SET_COORDINATES,
  GET_CEP,
  GET_CEP_FAILED,
  GET_CEP_COMPLETED,
  SET_CEP,
  SET_ADDRESS_COMPLEMENT
};
